import { useEffect } from 'react'

interface Seo {
  title: string
  description?: string
  /**
   * Die kanonische Adresse des Ladens (config.primaryHost).
   *
   * Ein Laden ist oft unter mehreren Adressen erreichbar — mit und ohne www,
   * die alte und die neue. Ohne kanonischen Verweis wertet eine Suchmaschine
   * dieselbe Seite mehrfach und rechnet sie gegeneinander auf.
   */
  canonicalHost?: string
}

function metaTag(name: string): HTMLMetaElement {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  return tag
}

/**
 * Setzt Titel, Beschreibung und kanonische Adresse der aktuellen Seite.
 *
 * Das geschieht im Browser, nicht auf dem Server: Diese Stufe liefert eine
 * reine Clientanwendung aus. Für Suchmaschinen, die JavaScript ausführen,
 * reicht das; wer mehr will, braucht Vorabrendern — das ist bewusst nicht
 * Teil dieser Stufe.
 */
export function useSeo({ title, description, canonicalHost }: Seo): void {
  useEffect(() => {
    document.title = title
    if (description) metaTag('description').setAttribute('content', description)

    // Auch für soziale Netze — sie lesen og:, nicht description.
    let og = document.head.querySelector<HTMLMetaElement>('meta[property="og:title"]')
    if (!og) {
      og = document.createElement('meta')
      og.setAttribute('property', 'og:title')
      document.head.appendChild(og)
    }
    og.setAttribute('content', title)

    if (canonicalHost) {
      let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
      if (!link) {
        link = document.createElement('link')
        link.setAttribute('rel', 'canonical')
        document.head.appendChild(link)
      }
      link.setAttribute('href', `https://${canonicalHost}${window.location.pathname}`)
    }
  }, [title, description, canonicalHost])
}
